import React, { useEffect } from "react";
import { Button } from "../../../common/Button/Button";
import Checkbox from "../../../common/Checkbox/Checkbox";
import ReactTable from "react-table";
import moment from "moment";
import "react-table/react-table.css";
import find from "lodash/find";
import { getServiceTypesMaster, getUser } from "../../../utils/localStorage";
import NeftModal from "../Handholder/NeftModal";
import NotesFacilitatorViewModal from "./NotesFacilitatorViewModal";
import AssignServicePartnerModal from "./AssignServicePartnerModal";
import AssignExternalServicePartnerModal from "./AssignExternalServicePartnerModal";

import ConfirmationModal from "./ConfirmationModal";
import StateChangeModalSPM from "./StateChangeModalSPM";
import StateChangeLogModalSPM from "./StateChangeLogModalSPM";
import StateAuditLogDropdown from "./StateAuditLogDropdown";
import { URL_CALCULATOR } from "../../../utils/urls";
import { useState } from "react";
import { DND_LINK } from "../../../utils/constants";
import CancellationReasonModal from "../Handholder/CancellationReasonModal";
import Spinner from "../../../common/Spinner/Spinner";

export default function FacilitatorDataTable(props) {
	/**Cancellation reason */

	const toggleStatusChangeModal = (e) => {
		if (e.nResourceInstanceId) props.onSelectServiceRequest(e);
		else props.onSelectServiceRequest(null);
		setShowStatusChangeModal(!showStatusChangeModal);
	};
	const [showStatusChangeLogModal, setShowStatusChangeLogModal] = useState(
		false
	);
	const toggleStatusChangeLogModal = (e) => {
		if (e.nResourceInstanceId) props.onSelectServiceRequest(e);
		else props.onSelectServiceRequest(null);
		setShowStatusChangeLogModal(!showStatusChangeLogModal);
	};
	const [showStatusChangeModal, setShowStatusChangeModal] = useState(false);

	const toggleConfirmationModal = () => {
		setShowConfirmationModal(!showConfirmationModal);
	};
	const [showConfirmationModal, setShowConfirmationModal] = useState(false);
	const [selectedStatus, setSelectedStatus] = useState({});
	const handleClick = (f, e) => {
		if (f.target.name !== undefined) {
			if (f.target.name === "cancelled") {
				props.toggleCancellationReasonModal();
				setSelectedStatus({ statusName: f.target.name, service: e });
			} else {
				toggleConfirmationModal();
				// toggleStatusChangeModal();
				setSelectedStatus({ statusName: f.target.name, service: e });
			}
		}
	};
	const changeState = () => {
		props.changeState(selectedStatus);
		if (selectedStatus.statusName !== "cancelled")
			toggleConfirmationModal();
	};

	function getReCalculateURL(
		sServiceState,
		paymentMode,
		nResourceInstanceId,
		catalogId
	) {
		let pricingAndProcessingMode = props.allCatalogs.filter(
			(e) => e["sCatalogueId"] === catalogId
		);
		let isDynamic = false;
		if (
			pricingAndProcessingMode.length > 0 &&
			pricingAndProcessingMode[0]["sMode"].split("_")[0] !== "DYNAMIC"
		) {
			isDynamic = true;
		}
		if (
			sServiceState === "Full Payment Received" ||
			sServiceState === "Delivered" ||
			paymentMode !== "2_Step_Payment" ||
			isDynamic
		) {
			return null;
		} else {
			return URL_CALCULATOR + String(nResourceInstanceId);
		}
	}
	function getReCalculateURLClassName(sServiceState, paymentMode, catalogId) {
		let pricingAndProcessingMode = props.allCatalogs.filter(
			(e) => e["sCatalogueId"] === catalogId
		);
		let isDynamic = false;
		if (
			pricingAndProcessingMode.length > 0 &&
			pricingAndProcessingMode[0]["sMode"].split("_")[0] !== "DYNAMIC"
		) {
			isDynamic = true;
		}
		if (
			sServiceState === "Full Payment Received" ||
			sServiceState === "Delivered" ||
			paymentMode !== "2_Step_Payment" ||
			isDynamic
		) {
			return "disableLink";
		} else {
			return "";
		}
	}

	const user = getUser();
	const getServiceName = (original) => {
		if (!original) return;
		const found = find(getServiceTypesMaster(), {
			sServiceCode: original.sServiceCode,
		});
		if (found) {
			return found.sServiceName;
		}
		return "";
	};
	const NoDataComponent = (p) => {
		return <div>No data</div>;
	};
	const columns = [
		{
			id: "sServiceCode",
			Header: "Service Details",
			accessor: "sServiceCode",
			width: 170,
			Cell: ({ original }) => {
				return (
					<>
						<span>{getServiceName(original)}</span>
						<br></br>
						<span> ({original["sServiceDisplayName"]})</span>
						<br></br>
						<span>{original["nResourceInstanceId"]}</span>
						<br></br>
						<span>{original["sPackageOfferTitle"]?original["sPackageOfferTitle"]:""}</span>
						<br></br>
						<span>{original["nPackageInstanceId"]?
						(
							`Pkg/Off Instance Id:${original["nPackageInstanceId"]}`):""}
						</span>
					</>
				);
			},
		},

		{
			id: "nResourceInstanceId",
			Header: "Customer Details",
			accessor: "nResourceInstanceId",
			Cell: ({ original }) =>
				original["customer_meta"] ? (
					<span>
						{original["customer_meta"]["first_name"]}{" "}
						{original["customer_meta"]["last_name"]}
						<br></br>
						<a href="#" onClick={(e) => props.toggleUserProfileModal(e, original)} target="_self">
						{original["sEmailAddress"]}
						</a>
						<br></br>
						{original["sContactNumber"]}
						<br></br>
						<small>DND Date: </small>
						{original["customer_meta"]["DNDDate"] ? (
							<small>
								{moment(
									original["customer_meta"]["DNDDate"]
								).format("lll")}{" "}
							</small>
						) : (
							<small>Not Available</small>
						)}
						<br></br>
						<a
							href={`${
								original["sEmailAddress"]
									? `/home/three-sixty-degree-view?email=${original["sEmailAddress"]}`
									: `/home/three-sixty-degree-view`
							}  `}
							target="_blank"
						>
							360 View
						</a>
						{"|"}
						<a href={DND_LINK} target="_blank">
							Extend DND
						</a>
						{
							original.refCurrentState&&original.refCurrentState.sServiceState=="Delivered"?
							(
								<>
									<br></br><a href="javascript:void(0);" onClick={(e) => props.toggleShowFeedbackModal(e, original)} target="_self">
									{"Feedback"}
									</a>
								</>								
							):
							(
								""
							)
						}
					</span>
				) : (
					<span></span>
				),
		},

		{
			id: "dtServiceProgression",
			Header: "Progressed On",
			accessor: "dtServiceProgression",
			Cell: ({ original }) => (
				<>
					{" "}
					{moment(
						moment.utc(original["dtServiceProgression"]).toDate()
					).format("MMMM Do YYYY")}
					<br />
					{moment(
						moment.utc(original["dtServiceProgression"]).toDate()
					).format("h:mm:ss a")}
					<br></br>
					<span>
						Entry Point:{" "}
						{original["sEntryPoint"]
							? original["sEntryPoint"]
							: "Not Available"}
					</span>
					<br></br>
					<span>
						EHH:{" "}
						{original["sExternalHHEmail"]
							? original["sExternalHHEmail"]
							: "Not Available"}
					</span>
					<br></br>
					<span>
						EHH Org:{" "}
						{original["sEhhOrg"]
							? original["sEhhOrg"]
							: "Not Available"}
					</span>
					<br></br>
					<span>
						EHH Contact Number:{" "}
						{original["sEhhContactNumber"]
							? original["sEhhContactNumber"]
							: "Not Available"}
					</span>
					<br></br>
					<span>
						Device Type:{" "}
						{original["sDeviceType"] ? (
								<>{original["sDeviceType"]}</>
							):("Not Available")}
					</span>
					<br></br>
					<span>
						Stay Engaged with EHH:{" "}
						{original["bStayEngagedWithEhh"] ? "Yes" : "No"}
					</span>
					<br></br>
					{original["urlInvoice"] ? (
						<span>
							<a href={original["urlInvoice"]} target="_blank">
								Break-up
							</a>
						</span>
					) : (
						""
					)}
				</>
			),
		},

		{
			id: "dtLastFacilitatorAssigned",
			Header: "Facilitator Assigned On",
			accessor: "dtLastFacilitatorAssigned",
			Cell: ({ original }) => (
				<>
					{" "}
					{moment(
						moment
							.utc(original["dtLastFacilitatorAssigned"])
							.toDate()
					).format("MMMM Do YYYY")}
					<br />
					{moment(
						moment
							.utc(original["dtLastFacilitatorAssigned"])
							.toDate()
					).format("h:mm:ss a")}
				</>
			),
		},

		{
			id: "sBusinessName",
			Header: "Business Details",
			accessor: "sBusinessName",
			Cell: ({ original }) => (
				<span>
					{original.sBusinessName ? (
						<>
							<span>{original.sBusinessName}</span>
						</>
					) : (
						""
					)}
					<br></br>
						{original.refBusinessSectorNew ? (
							<span>
								{
									original["refBusinessSectorNew"][
										"sSectorName"
									]
								}
							</span>
						) : (
							""
						)}
				</span>
			),
		},

		{
			id: "sBusinessPincode",
			Header: "Pincode",
			accessor: "sBusinessPincode",
			Cell: ({ original }) => (
				<span>
					{original.sBusinessPincode ? (
						<>
							<span title={`${original.sBusinessCity ?original.sBusinessCity:""}${" "}${original.sBusinessState ?original.sBusinessState:""}`}>{original.sBusinessPincode}</span>
						</>
					) : (
						""
					)}
				</span>
			),
		},
		
		{
			id: "bCouponApplied",
			Header: "Coupon Details",
			accessor: "bCouponApplied",
			Cell: ({ original }) => (
				<span>
					<span>
						Coupon Applied:{" "}{original["bCouponApplied"]? "Yes": "No"}
					</span>
					<br></br>
					<span>
						Coupon Code:{" "}{original["sCouponCode"]? original["sCouponCode"]: "NA"}
					</span>
					<br></br>
					<span>
						Coupon Discount Amount:{" "}{original["fDiscountAmount"]? original["fDiscountAmount"]: "NA"}
					</span>
					<br></br>
				</span>
			),
		},

		{
			id: "sPaymentStatus",
			Header: "Payment Status",
			accessor: "sPaymentStatus",
			width: 125,
			Cell: ({ original }) =>
				original.sPaymentStatus ? original.sPaymentStatus : "N/A",
		},
		{
			id: "refExternalServicePartner",
			Header: "Ext Service Partner",
			accessor: "refExternalServicePartner",
			Cell: ({ original }) => (
				<div>
					<span>
						{original["refExternalServicePartner"] && (
							<>
								{original["refExternalServicePartner"][
									"sName"
								] &&
									original["refExternalServicePartner"][
										"sName"
									]}
							</>
						)}
					</span>
					<span>
						{original["refExternalServicePartner"] ? (
							<>
								<br />
								{
									original["refExternalServicePartner"][
										"sServicePartnerEmail"
									]
								}
							</>
						) : (
							"No partner assigned"
						)}{" "}
					</span>
					<span>
						{original["refExternalServicePartner"] && (
							<>
								{original["refExternalServicePartner"][
									"sMobileNumber"
								] && (
									<>
										<br />
										{
											original[
												"refExternalServicePartner"
											]["sMobileNumber"]
										}
									</>
								)}
							</>
						)}
					</span>
					<span>
						{original["refExternalServicePartner"] && (
							<>
								{original["refExternalServicePartner"][
									"sServicePartnerOrg"
								] && (
									<>
										<br />
										{
											original[
												"refExternalServicePartner"
											]["sServicePartnerOrg"]
										}
									</>
								)}
							</>
						)}
					</span>
					{original["dtLastExternalServicePartnerAssigned"] && (
						<span>
							<>
								<br />
								<em>
									<span>Assigned on :</span>
									<br />
									{moment(
										moment
											.utc(
												original[
													"dtLastExternalServicePartnerAssigned"
												]
											)
											.toDate()
									).format("MMM Do YYYY")}
									<br />
									{moment(
										moment
											.utc(
												original[
													"dtLastExternalServicePartnerAssigned"
												]
											)
											.toDate()
									).format("h:mm:ss a")}
								</em>
							</>
						</span>
					)}
					<br></br>
					<button
						className={`notes-button ${
							original["refFacilitator"] &&
							original["refFacilitator"]["email"] === user.email
								? ""
								: "disable"
						}`}
						onClick={(f) =>
							props.toggleExternalServicePartnerModal(original)
						}
					>
						Assign
					</button>
					{/* clear button */}
					<button
						className={`notes-button ${
							original["refExternalServicePartner"]
								? ""
								: "disable"
						} ${
							original["refFacilitator"] &&
							original["refFacilitator"]["email"] === user.email
								? ""
								: "disable"
						}`}
						onClick={(f) =>
							props.saveExternalServicePartner(original, true)
						}
					>
						Clear
					</button>
				</div>
			),
		},
		{
			id: "refServicePartner",
			Header: "Service Partner",
			accessor: "refServicePartner",
			Cell: ({ original }) => (
				<div>
					<span>
						{original["refServicePartner"]
							? original["refServicePartner"]["email"]
							: "No partner assigned"}{" "}
					</span>
					<br></br>
					<span>
						{original["refServicePartner"]
							? original["refServicePartner"]["is_active"]
								? original["refServicePartner"]["out_of_office"]
									? "Out of Office"
									: "Active"
								: "Deactivated"
							: ""}
					</span>
					<span>
						{original["dtLastServicePartnerAssigned"] && (
							<>
								{" "}
								<br />
								<em>
									<span>Assigned on :</span>
									<br />
									{moment(
										moment
											.utc(
												original[
													"dtLastServicePartnerAssigned"
												]
											)
											.toDate()
									).format("MMM Do YYYY")}
									<br />
									{moment(
										moment
											.utc(
												original[
													"dtLastServicePartnerAssigned"
												]
											)
											.toDate()
									).format("h:mm:ss a")}
								</em>
							</>
						)}
					</span>
					<br></br>
					<button
						className={`notes-button ${
							original["refFacilitator"] &&
							original["refFacilitator"]["email"] ===
								props.user.email
								? ""
								: "disable"
						}`}
						onClick={(f) =>
							props.toggleServicePartnerModal(original)
						}
					>
						Assign
					</button>
					{/* clear button */}
					<button
						className={`notes-button ${
							original["refServicePartner"] ? "" : "disable"
						} ${
							original["refFacilitator"] &&
							original["refFacilitator"]["email"] ===
								props.user.email
								? ""
								: "disable"
						}`}
						onClick={(f) =>
							props.saveServicePartner(original, true)
						}
					>
						Clear
					</button>
					<br></br>
					<u>
						<span>
							<a
								className={getReCalculateURLClassName(
									original["refCurrentState"][
										"sServiceState"
									],
									original["sPaymentMode"],
									original["sCatalogueId"]
								)}
								href={getReCalculateURL(
									original["refCurrentState"][
										"sServiceState"
									],
									original["sPaymentMode"],
									original["nResourceInstanceId"],
									original["sCatalogueId"]
								)}
								target="_blank"
							>
								Re-calculate
							</a>
						</span>
					</u>
				</div>
			),
		},

		{
			id: "notes",
			Header: "Notes",
			accessor: "notes",
			Cell: ({ original }) => (
				<button
					className={`notes-button`}
					onClick={(f) => props.toggleNotesModal(original)}
				>
					Notes
				</button>
			),
		},

		{
			id: "refCurrentState",
			Header: "Current State",
			accessor: "refCurrentState",
			Cell: ({ original }) =>
				original["refCurrentState"] ? (
					<>
						{" "}
						<a
							style={{ textDecoration: "underline" }}
							onClick={() => toggleStatusChangeModal(original)}
							title={original["sServiceCancellationReason"]?
								original["sServiceCancellationReason"] ==="Other"? 
								original["sServiceCancellationReasonOtherDescription"]: 
								original["sServiceCancellationReason"]:""}
						>
							{" "}{original["refCurrentState"]["sServiceState" ]}{" "}
						</a>
						{" "}
						<br></br>
						{" "}
						<a
							style={{ textDecoration: "underline" }}
							onClick={() => {
								toggleStatusChangeLogModal(original);
							}}
						>
							{" "}Status Log{" "}
						</a>
						{" "}
					</>
				) : (
					""
				),
		},
	];
	return (
		<>
			{props.isLoadingSpinnerForMyProgression && (
				<>
					<Spinner className="center" />
				</>
			)}
			<ReactTable
				data={props.data || []}
				columns={columns}
				manual
				pages={props.pages}
				page={props.page}
				style={{
					overflowY: "auto",
					height: "800px"}}
				pageSize={props.pageSize}
				NoDataComponent={NoDataComponent}
				pageSizeOptions={[10,20,25,50,75,100]}
				onFetchData={(state, instance) => {
					props.onFetchServiceRequests(instance, true);
					// if (props.page === 0) instance.state.page = 0;
				}}
				// getTdProps={(state, rowInfo, column) => {
				//   if (column && column.id !== "checkbox") {
				//     return {
				//       onClick: e => props.onUserRowClick(rowInfo)
				//     };
				//   } else {
				//     return { onClick: (e, h) => h() };
				//   }
				// }}
				NextComponent={(instance) => (
					<Button className="mt3" {...instance}>
						Next
					</Button>
				)}
				PreviousComponent={(instance) => (
					<Button className="mt3" {...instance}>
						Previous
					</Button>
				)}
			/>

			<NotesFacilitatorViewModal
				auditTrail={props.auditTrail}
				changeSelectedNotesDetails={props.changeSelectedNotesDetails}
				notesHistory={props.notesHistory}
				notesDetails={props.notesDetails}
				isOpen={props.showNotesModal}
				toggleModal={props.toggleNotesModal}
				onInputChange={props.onNotesChange}
				onSaveNotesDetails={props.onSaveNotesDetails}
				isOpenConfirmationModal={props.showConfirmationModalNotes}
				toggleConfirmationModal={props.toggleConfirmationModalNotes}
				confirmChangeNotes={props.confirmChangeNotes}
				/*Need to talk to SP */
				needToTalkToSPOptions={props.needToTalkToSPOptions}
				selectedNeedToTalkToSPOption={props.selectedNeedToTalkToSPOption}
				setSelectedNeedToTalkToSPOption={props.setSelectedNeedToTalkToSPOption}
				service={props.selectedServiceRequest}
				onUpdateNeedToTalkToSPFlag={props.onUpdateNeedToTalkToSPFlag}
				/*End*/
			/>
			<AssignServicePartnerModal
				isOpen={props.showServicePartnerModal}
				toggleModal={props.toggleServicePartnerModal}
				currentServicePartner={props.currentServicePartner}
				servicePartnerList={props.servicePartnerList}
				saveServicePartner={props.saveServicePartner}
				toggleServicePartner={props.toggleServicePartner}
			/>
			<AssignExternalServicePartnerModal
				isLoading={props.isLoading}
				isOpen={props.showExternalServicePartnerModal}
				toggleModal={props.toggleExternalServicePartnerModal}
				currentServicePartner={props.currentExternalServicePartner}
				servicePartnerList={props.externalServicePartnerList}
				saveServicePartner={props.saveExternalServicePartner}
				toggleServicePartner={props.toggleExternalServicePartner}
			/>
			{/* <ConfirmationModal
        message="Are you sure about changing the status?"
        isOpen={showConfirmationModal}
        toggleModal={props.toggleConfirmationModal}
        changeState={props.changeState}
      /> */}
			<StateChangeModalSPM
				isLoading={props.isLoadingStateChange}
				service={props.selectedServiceRequest}
				handleClick={handleClick}
				isOpen={showStatusChangeModal}
				toggleModal={toggleStatusChangeModal}
				showConfirmationModal={showConfirmationModal}
				toggleConfirmationModal={toggleConfirmationModal}
				/**NEFT Modal */
				isLoadingNEFT={props.isLoadingNEFT}
				isNeftModalOpen={props.isNeftModalOpen}
				toggleNeftModal={props.toggleNeftModal}
				neftDetails={props.neftDetails}
				onNeftDetailsChanged={props.onNeftDetailsChanged}
				onSaveNeftDetails={props.onSaveNeftDetails}
				/** */
				sendPaymentLink={props.sendPaymentLink}
				message="Are you sure about changing the status?"
				isOpenConfirmation={showConfirmationModal}
				toggleModalConfirmation={toggleConfirmationModal}
				changeState={changeState}
				/** Cancellation reason modal*/
				toggleCancellationReasonModal={
					props.toggleCancellationReasonModal
				}
				showSendNeftDetailsModal={props.showSendNeftDetailsModal}
				setShowSendNeftDetailsModal={props.setShowSendNeftDetailsModal}

				/**Refund Modal */
				isLoadingRefund={props.isLoadingRefund}
				isRefundModalOpen={props.isRefundModalOpen}
				toggleRefundModal={props.toggleRefundModal}
				refundDetails={props.refundDetails}
				onRefundDetailsChanged={props.onRefundDetailsChanged}
				onSaveRefundDetails={props.onSaveRefundDetails}
				cancellationReasonDropdownOptions={props.cancellationReasonDropdownOptions}
				onSelectCancellationReasonforRefund={props.onSelectCancellationReasonforRefund}
				selectedCancellationReasonforRefund={props.selectedCancellationReasonforRefund}
				enableOtherDescriptionTextboxforRefund={props.enableOtherDescriptionTextboxforRefund}
				cancellationReasonOtherDescriptionforRefund={props.cancellationReasonOtherDescriptionforRefund}
				onChangeCancellationReasonOtherDescriptionforRefund={props.onChangeCancellationReasonOtherDescriptionforRefund}
				/** */
			/>
			<CancellationReasonModal
				isDisabled={props.enableCancelButtonFlag}
				isOpen={props.showCancellationReasonModal}
				toggleModal={props.toggleCancellationReasonModal}
				cancellationReasonDropdownOptions={
					props.cancellationReasonDropdownOptions
				}
				onSelectCancellationReason={props.setSelectedCancellationReason}
				selectedCancellationReason={props.selectedCancellationReason}
				enableOtherDescriptionTextbox={
					props.enableOtherDescriptionTextbox
				}
				cancellationReasonOtherDescription={
					props.cancellationReasonOtherDescription
				}
				onChangeCancellationReasonOtherDescription={
					props.onChangeCancellationReasonOtherDescription
				}
				onChangeState={changeState}
			></CancellationReasonModal>
			<StateChangeLogModalSPM
				isOpen={showStatusChangeLogModal}
				toggleModal={toggleStatusChangeLogModal}
				stateAuditLog={props.stateAuditLog}
			></StateChangeLogModalSPM>
		</>
	);
}
